/**
 * The attribute the masthead's phone menu `<details>` carries. Lives in a plain
 * module because SiteHeader (a server component) and MastheadMenu (a client
 * island) both need the literal: a value exported from a 'use client' module
 * reaches a server component only as a client reference, not as a string.
 */
export const MASTHEAD_MENU_ATTRIBUTE = 'data-masthead-menu'
